module.exports = __webpack_public_path__ + "static/img/menu.2029f8ba.svg";